module.exports = __webpack_public_path__ + "static/media/challenger.2ee03ed2.pdf";